import { render, staticRenderFns } from "./leadsList.vue?vue&type=template&id=68d6f5b2&scoped=true&"
import script from "./leadsList.vue?vue&type=script&lang=js&"
export * from "./leadsList.vue?vue&type=script&lang=js&"
import style0 from "./leadsList.vue?vue&type=style&index=0&id=68d6f5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6f5b2",
  null
  
)

export default component.exports